var Invalid = 'Invalid';
var Valid = 'Valid';
var Pending = 'Pending';
var NoValidate = 'NoValidate';
var ValidationStates = { Invalid: Invalid, Valid: Valid, Pending: Pending, NoValidate: NoValidate };

export default ValidationStates;
export { Invalid, NoValidate, Pending, Valid };
